import { withJSXTemplate } from 'utilities/backbone';

import StorePickupOptionsTemplate from './templates/StorePickupOptionsTemplate';
import NoStoresMessageTemplate from './templates/NoStoresMessageTemplate';

(() => {

	const { lp } = window;
	const { bopus, globals } = lp;

	const ItemView = withJSXTemplate(window.Backbone.Marionette.ItemView);

	bopus.StorePickupOptionItemView = ItemView.extend({
		JSXTemplate: StorePickupOptionsTemplate,
		tagName: 'li',
		className () {

			return `field fieldRadio shipping-options__item${
				this.model.get('isSelected') ? ' shipping-options__item--selected' : ''
			}`;

		},
		ui: {
			jsStorePickupRadio: '.jsStorePickupRadio'
		},
		events: {
			'click @ui.jsStorePickupRadio': 'selectStore'
		},
		templateHelpers () {

			let formattedPhoneNumber = '';
			if (this.options.isStoreInventory) {

				formattedPhoneNumber = String(this.model.get('Phone')).replace(/\D/g, '');
				const matches = formattedPhoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
				formattedPhoneNumber = matches ? ` - (${matches[1]})-${matches[2]}-${matches[3]}` : '';

			}

			const showThisStoreLabel =				globals.isKiosk
				&& globals.storeNumber === this.model.get('StoreNumber')
				&& !this.options.isStoreInventory
				&& !globals.isEmployeeConnectedAsCustomer;

			return {
				id: this.cid,
				shortSku: this.options.shortSku,
				includeStoreNumber: this.options.includeStoreNumber,
				isStoreInventory: this.options.isStoreInventory,
				formattedPhoneNumber,
				showThisStoreLabel,
				showMyStoreLabel: showThisStoreLabel
					? false
					: this.model.get('IsDefaultStore')
					  && !this.options.isStoreInventory
					  && (!globals.isCustomerService || globals.isEmployeeConnectedAsCustomer)
			};

		},
		onRender () {

			this.ui.jsStorePickupRadio.filter(':checked').trigger('click', true);

		},
		selectStore (e, bypassTrigger) {

			// unhighlight selection including the one from other tabs
			$('.shipping-options__item--selected').removeClass('shipping-options__item--selected');

			// highlight selected store
			this.ui.jsStorePickupRadio.closest('.shipping-options__item').addClass('shipping-options__item--selected');

			if (!bypassTrigger) {

				$(bopus).trigger('storeSelected', [ $(e.target) ]);

			}

		}
	});

	bopus.StorePickupOptionsView = window.Backbone.Marionette.CollectionView.extend({
		el: '.jsStorePickupList',
		childView: bopus.StorePickupOptionItemView,
		childViewOptions () {

			return {
				isStoreInventory: this.$el.is('.jsInventoryStorePickupList'),
				shortSku: this.options.shortSku,
				includeStoreNumber: this.options.includeStoreNumber
			};

		},
		onBeforeRender () {

			// select the current store if current shipping option is store pickup
			if (this.options.selectedStoreNumber) {

				this.collection.find((storeModel) => {

					if (storeModel.get('StoreNumber') === this.options.selectedStoreNumber) {

						storeModel.set('isSelected', true);
						return true;

					}
					return false;

				});

			}

		}
	});

	bopus.NoStoresView = ItemView.extend({
		el: '.jsNoStoreMsg',
		JSXTemplate: NoStoresMessageTemplate
	});

})();
